export interface Visibility {
    groupIds?: string[];
    userIds?: number[];
}

export const isRestricted = (visibility?: Visibility): boolean =>
    (visibility?.groupIds?.length ?? 0) > 0 ||
    (visibility?.userIds?.length ?? 0) > 1;

export const isShared = (visibility?: Visibility): boolean =>
    (visibility?.groupIds?.length ?? 0) === 0 &&
    (visibility?.userIds?.length ?? 0) === 0;

export const isIndividual = (visibility?: Visibility): boolean =>
    (visibility?.userIds?.length ?? 0) > 0;

export const isGroupOnly = (visibility?: Visibility): boolean =>
    (visibility?.groupIds?.length ?? 0) > 0;
